import { getAuthToken } from '@/auth/token';
const DEFAULT_TIMEOUT_MS = 30_000;
export function getApiBase() {
    // In production the bundle is served from the same origin as the orchestrator
    // (nginx proxies /api/* to the eyva-api Service). In dev, Vite proxies /api.
    return import.meta.env.VITE_API_BASE ?? '';
}
export class HttpError extends Error {
    status;
    detail;
    constructor(status, message, detail) {
        super(message);
        this.status = status;
        this.detail = detail;
    }
}
export async function apiFetch(path, opts = {}) {
    const { method = 'GET', body, headers, signal, timeoutMs = DEFAULT_TIMEOUT_MS } = opts;
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(`Request timed out after ${Math.round(timeoutMs / 1000)}s`), timeoutMs);
    const combinedSignal = signal
        ? mergeSignals(signal, controller.signal)
        : controller.signal;
    try {
        const token = await getAuthToken();
        const res = await fetch(`${getApiBase()}/api${path}`, {
            method,
            headers: {
                Accept: 'application/json',
                ...(body !== undefined && !(body instanceof FormData)
                    ? { 'Content-Type': 'application/json' }
                    : {}),
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
                ...headers,
            },
            body: body === undefined
                ? undefined
                : body instanceof FormData
                    ? body
                    : JSON.stringify(body),
            signal: combinedSignal,
        });
        if (!res.ok) {
            let detail;
            let message = res.statusText;
            try {
                const data = await res.json();
                detail = data;
                if (typeof data?.detail === 'string')
                    message = data.detail;
                else if (typeof data?.message === 'string')
                    message = data.message;
            }
            catch {
                /* response was not JSON */
            }
            throw new HttpError(res.status, message, detail);
        }
        if (res.status === 204)
            return undefined;
        const text = await res.text();
        return (text ? JSON.parse(text) : undefined);
    }
    catch (error) {
        if (isAbortError(error)) {
            const reason = combinedSignal.reason;
            throw new Error(typeof reason === 'string' && reason ? reason : 'Request was cancelled before the server responded');
        }
        throw error;
    }
    finally {
        window.clearTimeout(timeout);
    }
}
function isAbortError(error) {
    return error instanceof DOMException && error.name === 'AbortError';
}
function mergeSignals(...signals) {
    const ctrl = new AbortController();
    for (const s of signals) {
        if (s.aborted) {
            ctrl.abort(s.reason);
            break;
        }
        s.addEventListener('abort', () => ctrl.abort(s.reason), { once: true });
    }
    return ctrl.signal;
}
